import React from 'react';

const ButtonBakeli = ({logo, link, text}) => {
  return (
    <a href={link} className="cursor-pointer pt-2 flex justify-center items-center border gap-4 rounded-full px-4 py-2 shadow-sm bg-white">
        <span className="text-[14px] text-blck mt-1 font-inter font-medium">{text}</span>
        <img src={logo} alt="img" className="w-[38px] h-[28px]" />
    </a>
  );
}

export default ButtonBakeli
